import api from "../../../services/api";

export interface GenderWholesaleCategoryReport {
  category: string;
  units_sold: number;
  revenue: number;
}

export const getWholesaleGenderCategoryReport = async (
  start_date: string,
  end_date: string
) => {
  const response = await api.get("/api/wholesale/sales_reports/categorize_by_gender", {
    params: { start_date, end_date },
  });
  return response.data as GenderWholesaleCategoryReport[];
};